<template>
  <div>
    <a-upload :action="uploadImgUrl" :headers="headers" @change="handleChange">
      <a-button> <a-icon type="upload" /> 上传附件 </a-button>
    </a-upload>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'UploadBtn',
  props: {
    // value: {
    //   type: String,
    //   default: ''
    // }
  },
  data () {
    return {
      // 上传附件
      uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
      }
    }
  },
  methods: {
    // 面谈-上传
    async handleChange (info) {
      if (info.file.status === 'done') {
        if (info.file.response.code !== 200) {
          this.$message.error('上传失败' + info.file.response.msg)
          return
        }
        console.log(info, 'info')
        this.$emit('input', info.file.response.data.url)
        this.$emit('ossId', info.file.response.data.ossId)
        this.$message.success('上传成功')
      }
      if (info.file.status === 'removed') {
        console.log(info, 'info')
        // this.ossid = info.fileList.map((item) => {
        //   return item.response.data.ossId
        // })
        // this.interviewRecordData.accessoryIds = this.ossid.toString()
        // console.log('ossidsd', this.interviewRecordData.accessoryIds)
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
